import { useState, useCallback, useEffect } from "react";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { TextField } from "@fluentui/react/lib/TextField";
import { AddIcon } from "@fluentui/react-icons-mdl2";

import { WithTranslator } from "Components/Generic/Translator";
import { IAddUserProps } from "./IAddUserProps";
import { useAddUserStyles } from "./UseAddUserStyles";

export const AddUser = WithTranslator((props: IAddUserProps): JSX.Element => {
  const { onAddUser, username, translator } = props;
  const [newUser, setNewUser] = useState(username);
  const styles = useAddUserStyles();

  useEffect(() => {
    setNewUser(username);
  }, [username]);

  const onSubmit = useCallback(() => {
    onAddUser(newUser);
    setNewUser(``);
  }, [newUser, onAddUser]);

  return (
    <>
      <TextField
        className={styles.input}
        placeholder={translator.get(`settings.usernames.adduser`, `Add new user`)}
        value={newUser}
        onChange={(_, user) => setNewUser(user)}
        onKeyUp={(e) => {
          if (e.key === `Enter`) {
            onSubmit();
          }
        }}
      />
      <PrimaryButton className={styles.button} onClick={onSubmit}>
        <AddIcon />
      </PrimaryButton>
    </>
  );
});
